import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import StatusBadge from '../../components/shared/StatusBadge';
import { formatDate, formatCurrency } from '../../utils/formatters';
import { Wheat, ChevronRight, Copy } from 'lucide-react';

export default function PedidoHistorico() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/pedidos?per_page=50')
      .then(r => setPedidos(r.data.pedidos || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="historico-page">
      <div className="bg-brand-primary px-4 pt-10 pb-5 text-white">
        <div className="flex items-center gap-2 mb-1">
          <img src="/logo-fatima.jpg" alt="Fátima Guterres" className="h-6 w-auto rounded object-cover" />
        </div>
        <h1 className="font-heading text-3xl font-bold">Meus Pedidos</h1>
      </div>

      <div className="px-4 py-4">
        {loading && (
          <div className="flex justify-center py-12">
            <div className="w-7 h-7 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" />
          </div>
        )}
        {!loading && pedidos.length === 0 && (
          <div className="text-center py-12">
            <p className="text-brand-text-muted font-body text-sm">Você ainda não fez nenhum pedido.</p>
            <Link to="/pedidos" className="btn-primary mt-4 inline-block py-3 px-6 rounded-full font-dashboard text-sm">Fazer primeiro pedido</Link>
          </div>
        )}
        <div className="space-y-3">
          {pedidos.map(p => (
            <div
              key={p.id}
              className="card-mobile flex items-center gap-3"
              data-testid="pedido-item"
            >
              <div className="flex-1 min-w-0 cursor-pointer" onClick={() => navigate(`/pedidos/${p.id}`)}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-dashboard font-bold text-brand-text text-sm">#{p.numero}</span>
                  <StatusBadge status={p.status} />
                </div>
                <p className="text-xs text-brand-text-muted font-body">{formatDate(p.data_pedido)} · {p.itens?.length || 0} item(ns) · Prazo: {p.prazo}</p>
                {p.total != null && <p className="text-xs font-semibold text-brand-primary mt-0.5">{formatCurrency(p.total)}</p>}
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <button
                  onClick={() => navigate(`/pedidos?base=${p.id}`)}
                  className="text-brand-text-muted hover:text-brand-primary transition-colors"
                  title="Duplicar pedido"
                  data-testid="duplicar-btn"
                >
                  <Copy className="w-4 h-4" />
                </button>
                <button onClick={() => navigate(`/pedidos/${p.id}`)} className="text-brand-text-muted hover:text-brand-primary transition-colors">
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
